<template>
  <section class="ribbon" :style="{ background: color }">
    {{ text }}
  </section>
</template>

<script setup>
import { ref, computed, watchEffect } from "vue";

const props = defineProps({
  text: {
    type: String,
    default: "sales",
  },
  color: {
    type: String,
    default: "var(--ribbon-primary-color)",
  },
});

const gradientColor = computed(() => {
  return `linear-gradient(45deg, ${props.color})`;
});
</script>
<style lang="scss" scoped>
.ribbon {
  --text-size: 0.8rem;
  width: max-content;
  text-transform: uppercase;
  font-size: var(--text-size);
  font-weight: bold;
  color: black;
}
.ribbon {
  --f: 0.5em;
  --r: 0.8em;
  padding-inline: 0.5em;
  line-height: 1.8;
  border-top: var(--f) solid #0005;
  border-right: var(--r) solid #0000;
  clip-path: polygon(
    0 100%,
    0 var(--f),
    var(--f) var(--f),
    100% var(--f),
    calc(100% - var(--r)) calc(50% + var(--f) / 2),
    100% 100%
  );
}
@media (max-width: 640px) {
  .ribbon {
    --text-size: 0.6rem;
  }
}
</style>

